import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container, Table} from 'react-bootstrap';
import Sidebar from './Sidebar';
import ToastConfirmation from './ToastConfirmation';
import {
  getFilterVariables,
  updateFilterVariable,
  deleteFilterVariable,
  addFilterVariables
} from './apiCalls';

// const { HOMEPAGE_CODE, LINKS_RRSS, ODISEA_FORM } = configAdmin

export default function FilterFeaturesEdit() {


  const [showToaster, setShowToaster] = useState(false);
  const [filterVariables, setFilterVariables] = useState([]);
  const [filterVariablesFormData, setFilterVariablesFormData] = useState([]);
  const [selectedFilterVariable, setSelectedFilterVariable] = useState();

  useEffect(() => {
    getFilterVariables().then(setFilterVariables);
  }, []);

  const saveFilterVariable = (id) => {
    if (filterVariablesFormData.hasOwnProperty(id)) {
      updateFilterVariable(id, filterVariablesFormData[id])
        .then(() => getFilterVariables())
        .then(updatedVariables => {
          setFilterVariables(updatedVariables);
          setSelectedFilterVariable(null);
          // Explicitly handle potential undefined selectedFilterVariable
          if (selectedFilterVariable) {
            const updatedSelectedVar = updatedVariables.find(v => v.id === selectedFilterVariable.id);
            if (updatedSelectedVar) {
              setSelectedFilterVariable(updatedSelectedVar);
            }
          }
          setShowToaster(true);
        })
        .catch((error) => {
          console.error("An error occurred while saving the variable:", error);
        });
    }
  };

  const handleDeleteFilterVariable = (id) => {
    deleteFilterVariable(id)
      .then(() => getFilterVariables())
      .then(updatedVariables => {
        setFilterVariables(prevFilterVariables => 
          prevFilterVariables.filter((item) => item.id !== id)
        );
        setFilterVariablesFormData(prevFormData => 
          Object.keys(prevFormData)
            .filter(key => key !== id)
            .reduce((obj, key) => {
              return {
                ...obj,
                [key]: prevFormData[key]
              };
            }, {})
        );
        setSelectedFilterVariable(null);
        setShowToaster(true);
      })
      .catch(error => {
        console.error("An error occurred when deleting the variable:", error);
      });
  };


  const handleAddFilterVariable = () => {
    const newVariable = {
      "variableName": "Nombre de variable",
      "selectLabel": "Etiqueta de variable",
      "checkGroupLabel": "Etiqueta de variable",
      "checkItems": [
        { "variableValue": "1", "label": "Item de ejemplo 1" },
        { "variableValue": "2", "label": "Item de ejemplo 2" }
      ]
    };
  
    addFilterVariables([newVariable])
      .then(() => getFilterVariables())
      .then(updatedVariables => {
        setFilterVariables(updatedVariables);
        setShowToaster(true);
      })
      .catch(error => {
        console.error("An error occurred:", error);
      });
  };


  const handleDeleteFilterOption = (id) => {

    let formData = selectedFilterVariable;
    formData.checkItems = formData.checkItems.filter((item, itemId) => itemId !== id)

    setFilterVariablesFormData({
      ...filterVariablesFormData,
      [selectedFilterVariable.id]: formData
    });

    setSelectedFilterVariable(formData);

    updateFilterVariable(selectedFilterVariable.id, formData)
      .then(() => getFilterVariables(setFilterVariables))
      .then(() => setShowToaster(true));
    
  }

  const handleAddFilterOption = () => {

    let formData = {...selectedFilterVariable};
    formData.checkItems.push({"variableValue":"NUEVO VALOR","label":"NUEVO ITEM"});
  
    updateFilterVariable(selectedFilterVariable.id, formData)
      .then(() => getFilterVariables())
      .then(setFilterVariables)
      .then(() => {
        setShowToaster(true);
      });
  };

  const filterFormContent = (
    <>
    <p>{/* JSON.stringify(filterVariablesFormData) */}</p>
    <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
    <Form>
      <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Variable</th>
            <th>Label</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            filterVariables && filterVariables.map((item, itemId) => {
              return (
                <tr>
                  <td>{/*itemId + 1*/ item.id }</td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta de variable"
                      defaultValue={ item.variableName }
                      value={ filterVariablesFormData[item.id]?.variableName ? filterVariablesFormData[item.id].variableName : item.variableName}
                      onChange={ (e) => {
                        setFilterVariablesFormData({
                          ...filterVariablesFormData,
                          [item.id] : {
                            'variableName': e.target.value,
                            'selectLabel': filterVariablesFormData[item.id] ? filterVariablesFormData[item.id]['selectLabel'] : item.selectLabel,
                            'checkGroupLabel': filterVariablesFormData[item.id] ? filterVariablesFormData[item.id]['checkGroupLabel'] : item.checkGroupLabel,
                            'checkItems': filterVariablesFormData[item.id] ? filterVariablesFormData[item.id]['checkItems'] : item.checkItems,
                          }
                        });
                      } }  
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Alias"
                      defaultValue={ item.selectLabel }
                      value={ filterVariablesFormData[item.id]?.selectLabel ? filterVariablesFormData[item.id].selectLabel : item.selectLabel}
                      onChange={ (e) => {
                        setFilterVariablesFormData({
                          ...filterVariablesFormData,
                          [item.id] : {
                            'variableName': filterVariablesFormData[item.id] ? filterVariablesFormData[item.id]['variableName'] : item.variableName,
                            'selectLabel': e.target.value,
                            'checkGroupLabel': filterVariablesFormData[item.id] ? filterVariablesFormData[item.id]['checkGroupLabel'] : item.checkGroupLabel,
                            'checkItems': filterVariablesFormData[item.id] ? filterVariablesFormData[item.id]['checkItems'] : item.checkItems,
                          }
                        });
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveFilterVariable(item.id);}}>Guardar</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteFilterVariable(item.id)}}>Eliminar</Button> </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>

      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddFilterVariable()}}>Agregar Variable</Button>

      </Form.Group>

      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label" htmlFor="edit-filters">Opciones para: </Form.Label>
        <Form.Select
          id="edit-alias"
          name="alias"
          value={selectedFilterVariable ? filterVariables.findIndex(variable => variable.id === selectedFilterVariable.id) : ""}
          onChange={(e) => {
            setSelectedFilterVariable(filterVariables[e.target.value]);
          }}
        >
          <option value="" defaultValue="selected">- Select -</option>
          { filterVariables && filterVariables.map((item, itemId) => <option key={item.id} value={itemId}>{item.selectLabel}</option>) }
        </Form.Select>

      </Form.Group>
      <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Valor</th>
            <th>Label</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            selectedFilterVariable?.checkItems && selectedFilterVariable.checkItems.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td>
                    <Form.Control
                      placeholder="Valor"
                      defaultValue={ selectedFilterVariable.checkItems[itemId].variableValue }
                      value={ filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id].checkItems[itemId].variableValue : selectedFilterVariable.checkItems[itemId].variableValue }
                      onChange={ (e) => {
                        let formData = {
                          ...filterVariablesFormData,
                          [selectedFilterVariable.id] : {
                            'variableName': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['variableName'] : selectedFilterVariable.variableName,
                            'selectLabel': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['selectLabel'] : selectedFilterVariable.selectLabel,
                            'checkGroupLabel': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['checkGroupLabel'] : selectedFilterVariable.checkGroupLabel,
                            'checkItems': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['checkItems'] : selectedFilterVariable.checkItems,
                          }
                        };

                        formData[selectedFilterVariable.id].checkItems[itemId] = {
                          'variableValue': e.target.value,
                          'label': formData[selectedFilterVariable.id].checkItems[itemId].label
                        }

                        setFilterVariablesFormData(formData);
                      } }  
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta"
                      defaultValue={ selectedFilterVariable.checkItems[itemId].label }
                      value={ filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id].checkItems[itemId].label : selectedFilterVariable.checkItems[itemId].label }
                      onChange={ (e) => {
                        let formData = {
                          ...filterVariablesFormData,
                          [selectedFilterVariable.id] : {
                            'variableName': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['variableName'] : selectedFilterVariable.variableName,
                            'selectLabel': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['selectLabel'] : selectedFilterVariable.selectLabel,
                            'checkGroupLabel': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['checkGroupLabel'] : selectedFilterVariable.checkGroupLabel,
                            'checkItems': filterVariablesFormData[selectedFilterVariable.id] ? filterVariablesFormData[selectedFilterVariable.id]['checkItems'] : selectedFilterVariable.checkItems,
                          }
                        };

                        formData[selectedFilterVariable.id].checkItems[itemId] = {
                          'variableValue': formData[selectedFilterVariable.id].checkItems[itemId].variableValue,
                          'label': e.target.value
                        }

                        setFilterVariablesFormData(formData);
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveFilterVariable(selectedFilterVariable.id);}}>Guardar</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteFilterOption(itemId)}}>Eliminar</Button> </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddFilterOption()}}>Agregar Opción</Button>
      </Form.Group>
    </Form>
    </>
  )

  return (
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <Card>
              <Card.Header>Filtros disponibles</Card.Header>
              <Card.Body>{ filterFormContent }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
